import { useEffect, useState } from 'react';

import { usePDSubscription } from '@/entities/market/hooks/usePDSubscription';
import { useUser } from '@/entities/user/model/user.store';
import { useTicketWallet } from '@/entities/user/model/wallet.store';
import { MIN_TICKETS_COUNT_TO_SPIN_BY_MODE } from '@/entities/wheel/constants';
import { WheelMode } from '@/entities/wheel/model/wheel.types';

export const useSpinMode = (): [WheelMode, (mode: WheelMode) => void, boolean] => {
  const user = useUser();

  const { isActivePDSubscription } = usePDSubscription();

  const { balance: ticketsCount = 0 } = useTicketWallet() ?? {};

  const isAvailableXSpin = !!user?.access?.spinXAvailable || isActivePDSubscription;

  const hasEnoughTicketsForSpin10 =
    ticketsCount >= MIN_TICKETS_COUNT_TO_SPIN_BY_MODE[WheelMode.SPIN_10];

  const [mode, setMode] = useState<WheelMode>(() =>
    isAvailableXSpin && hasEnoughTicketsForSpin10 ? WheelMode.SPIN_10 : WheelMode.SPIN
  );

  useEffect(() => {
    if (user?.access?.spinXAvailable || isActivePDSubscription) {
      if (hasEnoughTicketsForSpin10) {
        setMode(WheelMode.SPIN_10);
      }
    }
  }, [isActivePDSubscription, user?.access?.spinXAvailable, hasEnoughTicketsForSpin10]);

  useEffect(() => {
    if (ticketsCount < MIN_TICKETS_COUNT_TO_SPIN_BY_MODE[WheelMode.SPIN_10]) {
      setMode(WheelMode.SPIN);
    }
  }, [ticketsCount]);

  return [mode, setMode, isAvailableXSpin];
};
